export default __webpack_public_path__ + "static/push-e36f9d67a3b282ca9fe257e251449748.png";